import createReducer from '../../utils/createReducer';
import { BUY_PRODUCT_FOR_DELIVERY_LOADING_QUOTE } from '../../actions/orders/orderActionConstants';

const initialState = {
  isLoadingQuote: false,
};

export default createReducer(
  {
    [BUY_PRODUCT_FOR_DELIVERY_LOADING_QUOTE.START]: startLoadingQuote,
    [BUY_PRODUCT_FOR_DELIVERY_LOADING_QUOTE.STOP]: stopLoadingQuote,
  },
  initialState,
);

function startLoadingQuote(state) {
  return {
    ...state,
    isLoadingQuote: true,
  };
}

function stopLoadingQuote(state) {
  return {
    ...state,
    isLoadingQuote: false,
  };
}
